const screens = {
  default: {
    eventName: 'video_screen_interaction',
    categoryName: 'video_banner_interactions',
    pageName: 'video banner screen'
  },
  pdp: {
    eventName: 'pdp_screen_interaction',
    categoryName: 'pdp_video_interactions',
    pageName: 'pdp video screen'
  },
  landing: {
    eventName: 'landing_screen_interactions',
    pageName: 'landing'
  },
  shopTheLook: {
    categoryName: 'shop the look video interactions',
    pageName: 'shop the look video screen'
  },
  floatingWidgetModal: {
    eventName: 'video_screen_interaction',
    categoryName: 'video_banner_interactions_floating_widget',
    pageName: 'video banner screen'
  },
  floatingWidgetCard: {
    eventName: 'landing_screen_interactions',
    categoryName: 'video_banner_interactions_floating_widget',
    pageName: 'landing'
  }
};

export function videoBannerInfo(type) {
  let { eventName, categoryName, pageName } = screens.default;
  if (type) {
    eventName = screens[type].eventName ? screens[type].eventName : eventName;
    pageName = screens[type].pageName ? screens[type].pageName : pageName;
    categoryName = screens[type].categoryName ? screens[type].categoryName : categoryName;
  }
  return { eventName, categoryName, pageName };
}
